import type { ReactNode } from 'react';
import { cx } from '@miniapp-core/ui-kit';

export interface ImageTileButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  imageUrl?: string | null;
  className?: string;
  imageClassName?: string;
  overlay?: ReactNode;
  children: ReactNode;
}

export default function ImageTileButton({
  onClick,
  ariaLabel,
  imageUrl,
  className,
  imageClassName,
  overlay,
  children,
}: ImageTileButtonProps) {
  return (
    <button
      type="button"
      className={cx(
        'relative w-full cursor-pointer overflow-hidden border-none p-0 text-left transition-transform active:scale-[0.98]',
        className,
      )}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {imageUrl ? (
        <div
          className={cx('absolute inset-0 bg-cover bg-center', imageClassName)}
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      ) : null}
      {overlay}
      {children}
    </button>
  );
}
